import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { Chip } from "@mui/material";

interface UseTableColumnsConsultasPorNapProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsConsultasPorNap = (props?: UseTableColumnsConsultasPorNapProps) => {
    const { pagination } = props || {};

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            accessorKey: 'nombre_estado_puerto',
            header: 'ESTADO PUERTO',
            size: 100,
            Cell: ({ cell }) => {
                let estado_puerto = cell.getValue<string>();
                return (
                    <Chip label={estado_puerto || '-'} variant="filled" color={estado_puerto == "OCUPADO" ? 'success' : (estado_puerto == "POR LIBERAR" ? 'warning' : 'error')} />
                )
            }
        },
        {
            accessorKey: 'numero_puerto',
            header: '# PUERTO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_estado_servicio',
            header: 'ESTADO SERVICIO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_cliente',
            header: 'NOMBRE CLIENTE',
            size: 200,
            Cell: ({ cell }) => {
                const nombre = cell.getValue<string>() || '-';

                return nombre
                    .split(' ')
                    .map((parte, index) => {
                        if (index === 0) {
                            return parte;
                        }
                        if (index === 1) {
                            return parte.charAt(0) + '****';
                        }
                        return '****';
                    })
                    .join(' ');
            },
        },
        {
            accessorKey: 'sector',
            header: 'SECTOR',
            size: 150,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'olt',
            header: 'OLT',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
    ], [pagination]);

    return {
        columnBase
    }
}
